/**
 * Roles are an administrative dictionary of a few dozen rows, and every screen that reads them shows
 * them all: one window covers the whole list. The endpoint asks for the window explicitly, so the
 * query string is spelled once here instead of in every caller.
 */
export const ROLE_LIST_WINDOW_QUERY = "limit=200&offset=0";
